import Users from 'portal/src/components/systemAdministration/Users';
import { ALL_ORGANIZATIONS_ID } from 'portal/src/constants/ReservedIDs';

const SystemAdministrationUsers = () => (
  <Users organizationId={ALL_ORGANIZATIONS_ID} />
);

export default SystemAdministrationUsers;
